import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  // ✅ Use admin storage keys (set during admin login)
  const adminUser = JSON.parse(localStorage.getItem("adminUser"));
  const adminToken = localStorage.getItem("adminToken");

  // 🔒 If no admin token or not flagged as admin → redirect to admin login
  if (!adminUser || !adminToken || adminUser.role !== "admin") {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminRoute;
